var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsString } from "class-validator";
import { ProjectType } from "./study.dtos";
export var GlobalAdminProjectListStatus;
(function (GlobalAdminProjectListStatus) {
    GlobalAdminProjectListStatus["DRAFT"] = "DRAFT";
    GlobalAdminProjectListStatus["PUBLISHED"] = "PUBLISHED";
})(GlobalAdminProjectListStatus || (GlobalAdminProjectListStatus = {}));
export class GlobalAdminOrganizationProjectDto {
}
__decorate([
    IsString()
], GlobalAdminOrganizationProjectDto.prototype, "id", void 0);
__decorate([
    IsString()
], GlobalAdminOrganizationProjectDto.prototype, "name", void 0);
__decorate([
    IsEnum(ProjectType)
], GlobalAdminOrganizationProjectDto.prototype, "projectType", void 0);
__decorate([
    IsEnum(GlobalAdminProjectListStatus)
], GlobalAdminOrganizationProjectDto.prototype, "status", void 0);
export class GlobalAdminProjectOwnerDto {
}
__decorate([
    IsString()
], GlobalAdminProjectOwnerDto.prototype, "id", void 0);
__decorate([
    IsString()
], GlobalAdminProjectOwnerDto.prototype, "name", void 0);
__decorate([
    IsString()
], GlobalAdminProjectOwnerDto.prototype, "email", void 0);
